import 'bootstrap/dist/css/bootstrap.min.css';
import './App.css';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import ProjectIntroduction from './components/ProjectIntoduction';
import ColorMatchPage from './components/ColorMatchPage'; 
import ColorMatchResultPage from './components/ColorMatchResultPage';
import ProductMatchResult from './components/ProductMatchResult';

function App() {
  return (
    <Router>
      <Routes>
        <Route path="/" element={<ProjectIntroduction />} />
        <Route path="/colormatch" element={<ColorMatchPage />} />
        <Route path="/colormatch/result" element={<ColorMatchResultPage />} />
        <Route path="/colormatch/product-match-result" element={<ProductMatchResult />} />
        {/* <Route path="/colormatch/compare" element={<CompareResultModal />} /> */}
        <Route path="*" element={<Navigate to="/colormatch" replace />} />
      </Routes>
    </Router>
  );
}

export default App;
